import { Presentation } from 'lucide-react';
import { useContext } from 'react';

import { AppContext } from '@context';
import { Feature, FeatureHoookParams } from '..';
import { hasRole } from '../../auth/roles';
import { lang } from '@lang';
import { setGeneratePresentationModal, useAppDispatch } from '@state';
import { useAppRoles } from '@hooks';

type GeneratePresentationFeatureParams = FeatureHoookParams;

export const useGeneratePresentationFeature = (_params: GeneratePresentationFeatureParams = {}): Feature<void> => {
	const { appState: { customerDesigns: designs } } = useContext(AppContext);
	const dispatch = useAppDispatch();
	const appRoles = useAppRoles();

	const hasDesigns = designs.designs.length > 0 && designs.email !== null;
	const canGeneratePresentation = hasRole(appRoles, ['blueprint:super_admin', 'blueprint:admin', 'blueprint:srdesigner', 'blueprint:designer']);

	const [disabled, tooltip] = (() => {
		if (!canGeneratePresentation) return [true, lang.social.tooltip.designPackagesComingSoon];
		if (!hasDesigns) return [true, lang.social.tooltip.noGeneratePresentation];
		return [false, lang.social.tooltip.generatePresentation];
	})();

	return {
		name: 'generatePresentation',
		label: lang.social.label.generatePresentation,
		icon: (props = {}) => <Presentation {...props} />,
		tooltip,
		disabled,
		value: undefined,
		hidden: false,
		handler: () => {
			dispatch(setGeneratePresentationModal(true));
		}
	};
};
